import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ffe7fd8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe7fd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffe7fd8')) {
      api.createRecord('3ffe7fd8', component.options)
    } else {
      api.reload('3ffe7fd8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ffe7fd8&scoped=true&", function () {
      api.rerender('3ffe7fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/compoments/ITQ/index.vue"
export default component.exports